// to have bootstrap.js loaded async
import('./bootstrap');
